import firebase from "firebase";
import QuerySnapshot = firebase.firestore.QuerySnapshot;
import {ResultStatus} from "@/store/common/ResultStatus";
import ResultStatusFactory from "@/store/common/ResultStatusFactory";
import DeepCloner from "@/store/common/DeepCloner";
import {Location} from "@/store/modules/Locations/LocationEntitiy";

let unWatchRealtimeUpdate = new Function();


export class LocationRepository {

    public static watch(callback: (snapshot: QuerySnapshot) => void) {
        unWatchRealtimeUpdate = firebase.firestore()
            .collection("locations")
            .onSnapshot(callback, error => {
                console.log("location store snapshot error ", error);
            });
    }

    public static unWatch(): void {
        unWatchRealtimeUpdate();
    }

    public static add(param: Location) {
        return new Promise<ResultStatus>(async resolve => {
            const locationInFirebase = DeepCloner.copyJson(param);
            delete locationInFirebase.id;

            const updateResult = await firebase.firestore()
                .collection("locations")
                .doc()
                .set(locationInFirebase)
                .then(() => {
                    return ResultStatusFactory.makeSuccess();
                })
                .catch(error => {
                    return ResultStatusFactory.makeFailedByFirebaseError(error);
                });

            resolve(updateResult);
        });
    }


    static async delete(id: string) {
        return new Promise<ResultStatus>(async resolve => {
            const updateResult = await firebase.firestore()
                .collection("locations")
                .doc(id)
                .delete()
                .then(() => {
                    return ResultStatusFactory.makeSuccess();
                })
                .catch(error => {
                    return ResultStatusFactory.makeFailedByFirebaseError(error);
                });

            resolve(updateResult);
        });

    }
}
